import { REGULATIONS_DIALOG, UKGC_DIALOG } from '@components/Dialog/constants';
import { notificationTypes, ukgcNotifications } from '@store/constants/regulations';
import { dialog } from '@store/dialog';

export const handlePlayerNotifications = (data) => {
  const { type } = data;
  const actions = [];

  if (ukgcNotifications.includes(type)) {
    actions.push(dialog.open({
      name: UKGC_DIALOG,
      data,
    }),);
    return actions;
  }

  if (notificationTypes.includes(type)) {
    actions.push(dialog.open({ name: REGULATIONS_DIALOG, data }));
    return actions;
  }

  return actions;
};
